var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, CardHeader, Heading, Text } from 'grommet';
export var PlanHeader = function (_a) {
    var title = _a.title, price = _a.price, subtitle = _a.subtitle, _b = _a.highlight, highlight = _b === void 0 ? false : _b, rest = __rest(_a, ["title", "price", "subtitle", "highlight"]);
    return (_jsxs(CardHeader, __assign({ direction: "column", gap: "none", background: highlight ? "brand" : "background-front" }, rest, { children: [_jsx(Heading, __assign({ level: 5, textAlign: "center", weight: 300 }, { children: title.toUpperCase() })), _jsxs(Box, __assign({ border: { side: "horizontal", size: "xsmall", color: "light-3" }, alignSelf: "stretch", pad: "small", margin: { horizontal: "small" } }, { children: [_jsxs(Box, __assign({ direction: "row", align: "end", justify: "center", pad: "small" }, { children: [_jsx(Text, __assign({ size: "xsmall", color: highlight ? "white" : "status-error", weight: "bold", margin: { bottom: "xsmall" }, alignSelf: "start" }, { children: "$" })), _jsxs(_Fragment, { children: [_jsx(Text, __assign({ weight: "bold", size: "xxlarge", margin: { left: "xxsmall" } }, { children: price })), _jsx(Text, __assign({ size: "small" }, { children: "/Month" }))] })] })), _jsx(Text, __assign({ alignSelf: "center", size: "xxsmall" }, { children: subtitle.toUpperCase() }))] }))] })));
};
PlanHeader.defaultProps = {
    highlight: false,
};
//# sourceMappingURL=PlanHeader.js.map